export { default as AnnouncementDetailPage } from './announcement-detail-page.jsx';
export { default as ArticleDetailPage } from './article-detail-page.jsx';
export { default as ArticleListingPage } from './article-listing-page.jsx';
export { default as AuthorityDetailPage } from './authority-detail-page.jsx';
export { default as CalendarDetailPage } from './event-detail-page.jsx';
export { default as CalendarListingPage } from './calendar-listing-page.jsx';
export { default as CommunityListingPage } from './community-listing-page.jsx';
export { default as CourseDetailPage } from './course-detail-page.jsx';
export { default as DisciplineDetailPage } from './discipline-detail-page.jsx';
export { default as EventDetailPage } from './event-detail-page.jsx';
export { default as FaqPage } from './faq-page.jsx';
export { default as GlossaryPage } from './glossary-page.jsx';
export { default as Home } from './home.jsx';
export { default as JobDetailPage } from './job-detail-page.jsx';
export { default as JobListingPage } from './job-listing-page.jsx';
export { default as JobPostingPage } from './job-posting-page.jsx';
export { default as LandingPage } from './landing-page.jsx';
export { default as PersonDetailPage } from './person-detail-page.jsx';
export { default as ProgrammeDetailPage } from './programme-detail-page.jsx';
export { default as ProgrammeListingPage } from './programme-listing-page.jsx';
export { default as RegionDetailPage } from './region-detail-page.jsx';
export { default as TopicDetailPage } from './topic-detail-page.jsx';
